/* global Office console */

const BASE_URL = "https://api.starinsure.dev/api/v1";
const token =
  "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiI5YTBmNWQwMi05NTFjLTQwOWItYTQ3Ni0zZjhjODdlMDdmYWIiLCJqdGkiOiIxNTU1MmRmZmZkNjcxY2Y4ZWI2MGI2YjFmZGU4N2MxNmQ2MTAyZWEzNWE2M2Q4MGQ2NzY0MzU3OTcxYjFiYjJhODhkYWI3ZDViOGNkYjVhOCIsImlhdCI6MTc0MTE0NTE1OC41NTcwNTksIm5iZiI6MTc0MTE0NTE1OC41NTcwNjEsImV4cCI6MTc3MjY4MTE1OC41NTI0MzksInN1YiI6IjE1MjExIiwic2NvcGVzIjpbIioiXX0.lz3spwNyZ9TGiEYaSMz0RtFNCds_8_YfOYLynzP9SmysopgZT4TtjEgdbBTc_2jOBepuN0Cogc33n_pJIyGtbJEcPcY1kz8IrBAPQyiGMkNlNpTVr5FRK6BqxKOdve9tsbwQFGD3dpxurAJIxHoHLnnUIaBg5ujtsRthFMYLWVDJofD5C1u8JyydRCXfDphIXW5yuPKYrJ40bl3R8po5hvNDliy8jsa4yfoSRL3AxQKC65m_8XvuTXS172LhG-J6X6PZoXg91Z5EZ9FVPtufBD4uGjUcE8g3Is6tfrCp5nwwFQ0d2ZEAlAO5XgezvqAVV42I2yWjZAPIdXIwpra4VuxnpHabFWmLeA7KzyPz5pYXko3HiBdWlPJoO22Ok9QiUJTZZ-dK9sP0U2CwnLPJqURPqCiwAV6h8X82zqDvues48IIYOPX-LZZza4FDcLTxOQKsIRTbPsPDkJZ5jeB7rsOWunsfMw7oiAF4KsmpLxUG95yAi2GLtSncj42Y2SCLG7w1clbsSimnCugqG79IYq7boR1HZM0V8UWkhbLfSz5_V7leROnPteh8C8no08bzNNwVVTTILAOxvbr836uPk7e7sD8Lu_5R0dtwpsZ_nHWO3pCbZlzdbuU-flxMvnWbst7i9gRsKM4AiNtx-JCaoKSqwzoCpNDRteACVwSxO_I";

export const EmlAttachment = { name: "email.eml" };
export type AttachmentDetails = Office.AttachmentDetails;
export type Attachment = AttachmentDetails | typeof EmlAttachment;

export async function getDocStore(path: string) {
  // Fetch documents from the API
  // eslint-disable-next-line no-undef
  const response = await fetch(BASE_URL + "/document-store" + path, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  });

  if (!response.ok) {
    throw new Error("Failed to fetch documents");
  }

  const { data } = await response.json();
  return data;
}

export function getAttachmentFileObject(attachment: Attachment) {
  // eslint-disable-next-line no-undef
  return new Promise<File>((resolve, reject) => {
    if (attachment === EmlAttachment) {
      getEml().then((emlFile) => resolve(emlFile));
    }

    if ("id" in attachment) {
      Office.context.mailbox.item.getAttachmentContentAsync(
        attachment.id,
        { asyncContext: "Fetching attachment" },
        function (result) {
          if (result.status === Office.AsyncResultStatus.Succeeded) {
            const attachmentData = result.value;

            // Create a Blob from the attachment data base64 string
            // eslint-disable-next-line no-undef
            const base64Data = atob(attachmentData.content); // Convert base64 to binary string
            const byteCharacters = new Uint8Array(base64Data.length);
            for (let i = 0; i < base64Data.length; i++) {
              byteCharacters[i] = base64Data.charCodeAt(i);
            }
            // Create a File object from the Blob
            // eslint-disable-next-line no-undef
            const fileObject = new File([byteCharacters] as any[] as BlobPart[], attachment.name, {
              type: "application/octet-stream",
            });

            resolve(fileObject);
          } else {
            console.error("Error fetching attachment content:", result.error.message);
            reject();
          }
        }
      );
    }
  });
}

export function getEml() {
  // Get the EML content of the current email.
  // eslint-disable-next-line no-undef
  return new Promise<File>((resolve, reject) => {
    Office.context.mailbox.item.getAsFileAsync((result) => {
      if (result.status === Office.AsyncResultStatus.Succeeded) {
        // convert base64 string to eml file
        // eslint-disable-next-line no-undef
        const emlContent = atob(result.value);
        const byteCharacters = new Uint8Array(emlContent.length);
        for (let i = 0; i < emlContent.length; i++) {
          byteCharacters[i] = emlContent.charCodeAt(i);
        }

        // eslint-disable-next-line no-undef
        const fileObject = new File([byteCharacters] as any[] as BlobPart[], "email.eml", {
          type: "application/eml",
        });

        resolve(fileObject);
      } else {
        reject("Error fetching EML content: " + result.error.message);
      }
    });
  });
}

export async function getAttachments() {
  // Get the attachments of the current email.
  try {
    return Office.context.mailbox.item.attachments;
  } catch (error) {
    console.log("Error: " + error);
    return [];
  }
}

// eslint-disable-next-line no-undef
function chunkFile(file: File, chunkSize: number) {
  const chunks = [];
  let offset = 0;

  while (offset < file.size) {
    const chunk = file.slice(offset, offset + chunkSize);
    chunks.push(chunk);
    offset += chunkSize;
  }

  return chunks;
}

// eslint-disable-next-line no-undef
export async function uploadAttachments(files: File[], type: string, destination: string) {
  const chunkSize = 1024 * 1024 * 2; // 2MB default chunk size
  const uploadDir = "/uploads/temp";
  const postRoute = BASE_URL + "/upload";

  const uploadedFiles = [];

  for (const file of files) {
    const chunks = chunkFile(file, chunkSize);
    const totalChunks = chunks.length;

    for (let i = 0; i < totalChunks; i++) {
      // eslint-disable-next-line no-undef
      const formData = new FormData();
      formData.append("file", chunks[i]);
      formData.append("chunkIndex", i.toString());
      formData.append("totalChunks", totalChunks.toString());
      formData.append("fileName", file.name);
      formData.append("fileType", file.type);
      formData.append("directory", uploadDir);

      // eslint-disable-next-line no-undef
      const uploadRes = await fetch(postRoute, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      if (!uploadRes.ok) {
        let errorRes: any;
        try {
          errorRes = await uploadRes.json();
        } catch (error) {
          throw new Error("Unknown error");
        }
        throw new Error(errorRes.message || "Unknown error");
      }

      const uploaded = await uploadRes.json();

      if (!uploaded.done) {
        uploadedFiles.push(uploaded);
      }
    }
  }

  // eslint-disable-next-line no-undef
  const response = await fetch(BASE_URL + "/file-explorer/file", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      accept: "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify({
      files: uploadedFiles,
      [type]: destination,
    }),
  });

  if (!response.ok) {
    let errorRes: any;
    try {
      errorRes = await response.json();
    } catch (error) {
      throw new Error("Unknown error");
    }
    throw new Error(errorRes.message || "Unknown error");
  }

  const { data } = await response.json();
  return data;
}
